var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":"","no-gutter":""}},[_c('div',{class:"gradient-"+_vm.show})])}
var staticRenderFns = []

export { render, staticRenderFns }